import { __assign, __awaiter, __generator, __read, __spreadArray, __values } from "tslib";
import dom2canvas from 'html2canvas';
import { call } from './call';
import { native } from '../native';
import { uuid } from '../helpers/misc';
import { APP_VERSION } from '../constants';
import { delay } from '../utils';
import { SHARE_PARAMS } from '../constants/share';
export var shareImg = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var value;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call('SKShare', 'shareImg', params)];
            case 1:
                value = _a.sent();
                return [2 /*return*/, value];
        }
    });
}); };
export var shareImage = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var html, base64, scale, callback, shareBase64, width, height, canvas;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(options === null || options === void 0 ? void 0 : options.html))
                    return [2 /*return*/];
                html = options.html, base64 = options.base64, scale = options.scale, callback = options.callback;
                shareBase64 = base64;
                if (!!base64) return [3 /*break*/, 2];
                width = html.clientWidth * (scale || 2);
                height = html.clientHeight * (scale || 2);
                return [4 /*yield*/, dom2canvas(html, {
                        backgroundColor: 'transparent',
                        useCORS: true,
                        windowWidth: width,
                        windowHeight: height,
                        scale: 1,
                    })];
            case 1:
                canvas = _a.sent();
                shareBase64 = canvas.toDataURL();
                return [3 /*break*/, 4];
            case 2:
                if (!(base64 instanceof Promise)) return [3 /*break*/, 4];
                return [4 /*yield*/, base64];
            case 3:
                shareBase64 = _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, shareImg({ imageBase64: shareBase64.slice(22) })];
            case 5:
                _a.sent();
                callback === null || callback === void 0 ? void 0 : callback({ html: html, base64: shareBase64 });
                return [2 /*return*/];
        }
    });
}); };
var handleId = "shareLink_".concat(uuid(8));
var staticHandleMap = {
    imgNode: {
        title: '图片分享',
        icon: 'https://bbs.hycdn.cn/public/common-config/image/0510e6779bf397031b4eb79b14d916a0.png',
        callback: shareImage,
    },
};
var handleList = [];
var consumer = function (props) {
    var value = JSON.parse(props);
    var index = value.index;
    var item = handleList[index];
    if (!item) {
        console.log(index, handleList);
        console.log('没有匹配的内容');
        return;
    }
    item.callback(item.params);
};
export var shareLink = function (params, options) { return __awaiter(void 0, void 0, void 0, function () {
    var _loop_1, _a, _b, key, bridgeOptions, value;
    var e_1, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                native.setCallback(consumer, handleId);
                handleList = [];
                if (options) {
                    _loop_1 = function (key) {
                        var handleObj = __assign({}, staticHandleMap[key]);
                        var value_1 = options[key];
                        if (value_1) {
                            var params_1 = __assign({}, value_1);
                            switch (key) {
                                case 'imgNode': {
                                    if (!value_1.base64) {
                                        var html_1 = value_1.html, scale_1 = value_1.scale, handler_1 = value_1.handler;
                                        if (handler_1) {
                                            var callback_1 = handleObj.callback;
                                            handleObj.callback = function (options) { return handler_1(function () { return callback_1(options); }); };
                                        }
                                        params_1.base64 = new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
                                            var width, height, canvas, shareBase64;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        width = html_1.clientWidth * (scale_1 || 2);
                                                        height = html_1.clientHeight * (scale_1 || 2);
                                                        return [4 /*yield*/, dom2canvas(html_1, {
                                                                backgroundColor: 'transparent',
                                                                useCORS: true,
                                                                windowWidth: width,
                                                                windowHeight: height,
                                                                scale: 1,
                                                            })];
                                                    case 1:
                                                        canvas = _a.sent();
                                                        shareBase64 = canvas.toDataURL();
                                                        resolve(shareBase64);
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); });
                                    }
                                    break;
                                }
                            }
                            Object.assign(handleObj, { params: params_1 });
                            handleList.push(handleObj);
                        }
                    };
                    try {
                        for (_a = __values(Object.keys(staticHandleMap)), _b = _a.next(); !_b.done; _b = _a.next()) {
                            key = _b.value;
                            _loop_1(key);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                handleList.push.apply(handleList, __spreadArray([], __read((params.handleList || [])), false));
                bridgeOptions = __assign(__assign(__assign({}, SHARE_PARAMS), params), { handleId: handleId, handleList: handleList.map(function (_a) {
                        var title = _a.title, icon = _a.icon;
                        return ({ title: title, icon: icon });
                    }) });
                if (!['1.8.0', '1.9.0'].includes(APP_VERSION)) return [3 /*break*/, 2];
                call('SKShare', 'shareLink', bridgeOptions);
                return [4 /*yield*/, delay(350)];
            case 1:
                _d.sent();
                return [2 /*return*/, { code: 0, message: 'ok' }];
            case 2: return [4 /*yield*/, call('SKShare', 'shareLink', bridgeOptions)];
            case 3:
                value = _d.sent();
                return [2 /*return*/, value];
        }
    });
}); };
